import { createEmptySimulationResult } from '@exodus/web3-utils';
import { estimateFee } from './simulation/estimateFee.js';
import { simulateTransactions, } from './simulation/simulateTransactions.js';
import { tryEstimatingChangesLocally } from './simulation/tryEstimatingChangesLocally.js';
import { getDisplayDetails, getTxFeeDetails } from './transactions.js';
export const createSimulateTransactions = ({ apiEndpoint, headers }) => async ({ transactions, asset, origin, overrideApiEndpoint, }) => {
    // Ethereum transactions from web3 providers are always one item in an array.
    const transaction = transactions[0];
    const simulationResult = createEmptySimulationResult({
        asset,
    });
    simulationResult.balanceChanges.willPayFee.push({
        balance: estimateFee({ asset, transaction }),
        feeDetails: getTxFeeDetails(transaction),
    });
    if (!transaction.to) {
        return simulationResult;
    }
    const simulationTransactionInternalResult = await simulateTransactions({
        asset,
        transactions,
        apiEndpoint: overrideApiEndpoint || apiEndpoint,
        origin,
        simulationResult,
        headers,
    });
    if (simulationTransactionInternalResult.kind === 'error') {
        const simulatedLocally = tryEstimatingChangesLocally({
            asset,
            simulationResult,
            transaction,
        });
        if (!simulatedLocally) {
            simulationResult.warnings.push({
                kind: 'INTERNAL_ERROR',
                severity: 'HIGH',
                message: 'Balance changes cannot be estimated.',
            });
        }
        return simulationResult;
    }
    simulationResult.displayDetails = getDisplayDetails(simulationResult.balanceChanges.willApprove);
    return simulationResult;
};
